<app-link-entities
  key="linkEntities"
  [cols]="linkPermissionsColumnsConfig"
  [searchConfig]="linkPermissionsSearchConfig"
  [header]="'Link permissions' | translate"
>
  <ng-template kpdTemplate="tableExtra" let-column let-item="item" let-index="index">
    <div *ngIf="column.type === 'nameDeprecated'">
      {{ item[column.field] }}
      <span
        class="state-tag state-tag--deprecated"
        [attr.title]="item.deprecatedMessage"
        *ngIf="item.isDeprecated"
        translate
        >Deprecated</span
      >
    </div>
  </ng-template>
</app-link-entities>
<kpd-confirm-dialog key="confirmPermissionSetPermissionDelete"></kpd-confirm-dialog>
<app-permission-set-wizard-import [permissionSet]="permissionSet"></app-permission-set-wizard-import>

<kpd-hotkey keys="up" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="left" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="down" (action)="onNext()"></kpd-hotkey>
<kpd-hotkey keys="right" (action)="onNext()"></kpd-hotkey>

<div class="detail__grid">
  <div class="detail__alert">
    <kpd-alert type="warning" *ngIf="isKpdSet" icon="warning-standard">
      {{ 'Attention! This is a' | translate }}
      <img src="assets/logos/kpd-logo_36x16.svg" alt="KPD" class="kpd-logo--blue-sm" />
      {{ 'permisson set, editing is not allowed.' | translate }}
    </kpd-alert>

    <kpd-alert type="warning" *ngIf="!canManage" icon="warning-standard" translate>
      You are not authorized to change permissions for this permission set
    </kpd-alert>

    <ng-container *ngIf="saveErrors.length > 0">
      <kpd-alert type="error" *ngFor="let error of saveErrors" icon="warning-standard"> {{ error }} </kpd-alert>
    </ng-container>
  </div>

  <div class="detail__toolbar" *ngIf="isPermissionSetAvailable()">
    <kpd-action
      icon="import"
      (action)="onImport()"
      [disable]="permissionSet.isKpdSet || !canManage"
      [title]="'Import permissions' | translate"
      *kpdPermission="Permissions.PermissionsetImport"
    >
    </kpd-action>
    <kpd-action-bar *kpdPermission="Permissions.PermissionsetPermissionsUpdate">
      <kpd-action
        (action)="onAdd()"
        [disable]="isKpdSet || !canManage"
        icon="link"
        [title]="'Link Permission' | translate"
      >
      </kpd-action>
      <kpd-action
        (action)="onDelete()"
        [disable]="selectedKeys.length === 0 || isKpdSet || !canManage"
        icon="unlink"
        [title]="'Unlink Permission' | translate"
      >
      </kpd-action>
    </kpd-action-bar>
  </div>

  <div class="detail__main">
    <p-table
      dataKey="key"
      [value]="items"
      [selectionMode]="readOnlyMode ? null : 'multiple'"
      [scrollable]="true"
      class="table__fullheight"
      [resizableColumns]="true"
      [columns]="columnsConfig"
      [reorderableColumns]="true"
      [kpdTableRowSelection]="selectedKeys"
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
      kpdTableColumnReorder
      kpdTableSaveColumns="permissionSetDetailsPermissions"
      [metaKeySelection]="true"
      [index]="index"
      kpdTableShiftClick
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
    >
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" translate>No records found</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <ng-container *ngIf="col.field !== 'name'">
              <span [pTooltip]="rowData[col.field]" [tooltipPosition]="'top'" [tooltipStyleClass]="'tooltip'">{{
                rowData[col.field]
              }}</span>
            </ng-container>
            <ng-container *ngIf="col.field === 'name'">
              {{ rowData[col.field] }}
              <span
                class="state-tag state-tag--deprecated"
                [attr.title]="rowData.deprecatedMessage"
                *ngIf="rowData.isDeprecated"
                translate
                >Deprecated</span
              >
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
